import { createSlice } from "@reduxjs/toolkit";

const lensSlice = createSlice({
    name: "lens",
    initialState: {
        ron_lens_recommendation_image: "",
        recommendation_image_detail: {},
        currLens: "",
        lensCounter: 0,
        newImage: "",
        imageCompRadio: "objectDetection"
    },
    reducers: {
        handleLensCounter(state) {
            state.lensCounter += 1
        },
        handleLensRecommendationImage(state, action) {
            state.ron_lens_recommendation_image = action.payload
        },
        setCurrLens(state, action) {
            state.currLens = action.payload
        },
        handleImageDetail(state, action) {
            state.recommendation_image_detail = action.payload
        },
        setNewImage(state, action) {
            state.newImage = action.payload
        },
        setImageCompRadio(state, action) {
            state.imageCompRadio = action.payload
        },
    }
})

export const { setCurrLens, handleImageDetail, handleLensRecommendationImage, handleLensCounter, setNewImage, setImageCompRadio } = lensSlice.actions;
export default lensSlice.reducer;